import {createFileRoute} from '@tanstack/react-router';
import SportPlayers from '../../../../sports/SportPlayers.tsx';
import {SPORT_AREAS} from '../../../../sports/sportAreas.ts';

export const Route = createFileRoute('/_app/roundnet/players/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <SportPlayers sport={SPORT_AREAS.roundnet}/>
}
